import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { createUser } from 'src/services/napi/users/createUser';
import { useNotification } from '../../../providers/notificationsProvider';

const createUserFn = async ({ fullName, email, role, password, tags }) => {
  const currentProject = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject) return;
  const { _id: projectId } = currentProject;
  const name = fullName.split(' ')[0] || '';
  const surname = fullName.split(' ')[1] || '';
  const data = { email, name, password, role, surname, tags };
  await createUser(projectId, data);
};

export const useCreateUser = ({ onError, onSuccess }) => {
  const { notify } = useNotification();

  return useMutation((data) => createUserFn(data), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
